import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="left">
          <button className="privacy-policy-button">Privacy Policy</button>
        </div>
        <div className="center">
          <p>All rights reserved by Umar Murtaza</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
